import { useProductFilter, useSetProductFilter } from '@gripp/shared-logic';
import {
  countFilters,
  FilterHeaders,
  ProductsSearchInput,
  SlideAction,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';

export const ProductsFilters = () => {
  const navigate = useNavigate();
  const { currentViewMode, onSlideChange } = useSlideLayout();

  const { data: productFilter } = useProductFilter();
  const { mutateAsync: setProductFilter } = useSetProductFilter();
  const filterCount = countFilters(productFilter);

  const onFilterNavigate = async () => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }
    navigate('/products/filters');
  };

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders
        currentSearchKeyword={productFilter?.keyword}
        searchComponent={<ProductsSearchInput />}
        onFilterPress={onFilterNavigate}
        onSearchClose={() => setProductFilter({ keyword: '' })}
        filterCount={filterCount}
        Routes={{}}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 12,
  },
});
